import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';
import * as g from '../../castle-kit-grounds';

/**
 * EAST CLOISTER (Восточная галерея) — a tall, narrow covered ARCADE mirroring the west cloister, kept
 * deliberately SPARE and airy: a quiet, shaded transit spine. The HERO is the rhythmic COLONNADE of
 * pillars marching down the WEST wall; the single warm beat is one GARDEN BENCH pooled by a lamppost on
 * the EAST wall, flanked by two heraldic BANNERS. The long central walkway is left wholly OPEN — empty
 * stone is the composition. (Greenery was cut: it cluttered the seam and bled into the gardens next door.)
 *
 * Geometry: zone (2420,760) 380×1280 → centre (2610,1400). Doors on W (y1040,y1680), E (y970,y1440,y1870),
 * N (x2610), S (x2610) are kept clear — set-dressing hugs the walls, the central vertical walkway stays open.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // ── HERO: the colonnade — a rhythmic march of pillars down the WEST wall, framing the arcade. ──
  for (const py of [900, 1200, 1500, 1800]) {
    place(ctx, kit.pillar(art), 2450, py);
  }

  // ── EAST wall: two heraldic banners flanking the rest spot (kept off the three east door mouths). ──
  place(ctx, kit.banner(art, 0x2f4a8a, 100), 2790, 1080);
  place(ctx, kit.banner(art, 0x8a2f2f, 100), 2790, 1420);

  // ── The pause: one GARDEN BENCH facing west into the arcade (seat anchor = ecloister-bench). ──
  place(ctx, g.gardenBench(art, 72), 2730, 1240);

  // ── POOL LIGHT: a single lamppost warms the bench; one wall torch keeps the south end alive. ──
  place(ctx, g.lamppost(art), 2730, 1100);
  place(ctx, kit.wallTorch(art), 2440, 1680);
};

export default decorate;
